import ValueInterface, { SerializedValueType } from "./ValueInterface"
import { DivisionSign } from "./DivisionValue"
import { ProductSign } from "./ProductValue"

export const variables: string[] = [
  "x",
  "y",
  "z",
  "a",
  "b",
  "c",
  "r",
  "p",
  "⍺",
  "β",
  "Ɣ",
]

export type VariableType = (typeof variables)[number]

export type Sign = DivisionSign | ProductSign | "+" | "-"

export type Constant = {
  name: string
  value: ValueInterface
}

export default class EquationValue implements ValueInterface {
  constructor(
    private readonly a: ValueInterface,
    private readonly x: ValueInterface,
    private readonly b: ValueInterface,
    private readonly variable: VariableType,
    private readonly template: string,
    private readonly constants: Constant[] = [], // @todo ? replace a, b with constants, so we can use more than 2.
  ) {}

  public toString(): string {
    return this.template
      .replace("a", this.a.toString())
      .replace("b", this.b.toString())
      .replace("x", this.variable)
  }

  public normalize(): number {
    return this.x.normalize()
  }

  public clone(): EquationValue {
    return new EquationValue(
      this.a,
      this.x,
      this.b,
      this.variable,
      this.template,
      this.constants,
    )
  }

  public toJSON(): SerializedValueType {
    return {
      type: "equation",
      payload: {
        a: this.a.toJSON(),
        b: this.b.toJSON(),
        x: this.x.toJSON(),
        variable: this.variable,
        template: this.template,
        constants: this.constants.map((constant: Constant) => ({
          name: constant.name,
          value: constant.value.toJSON(),
        })),
      },
    }
  }
}
